import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

import appReducer from './slices/slice_app';
import gameReducer from './slices/slice_game';
import LobbyReducer from './slices/slice_lobby';
import TournamentReducer from './slices/slice_tournament';

const logger = createLogger({
  collapsed: true,
});

export const store = configureStore({
  reducer: {
    app: appReducer,
    game: gameReducer,
    lobby: LobbyReducer,
    tournament: TournamentReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
